<template>
  <div id="alertMessage" v-if="$store.state.multivariate.alert.active">
    <div
      class="alert"
      role="alert"
      :class="$store.state.multivariate.alert.level"
    >
      <!-- <button @click="$store.commit('multivariate/setAlert', { active: false })" type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button> -->
      {{ $store.state.multivariate.alert.message }}
    </div><!-- /.alert -->
  </div><!-- /#alert -->
</template>

<script>
export default {}
</script>

<style scoped>
/* Floats below the shared 56px plugin header. */
#alertMessage {
  position: fixed;
  z-index: 101;
  top: 68px;
  left: 80px;
  width: calc(100% - 160px);
  text-align: center;
}
</style>
